import cookies from "js-cookies";
import React from 'react';
import { addOffer } from '../../Actions/a.survey'
import { connect } from 'react-redux'
import BaseComponent from "../BaseComponent";

class Result extends BaseComponent {
    constructor() {
        super();
        this.state = {
            Form: {
                Offer: '',
                Status: false
            }
        }
     
    }

    handleSubmitOffer = (e) => {
        e.preventDefault();
        var localState = this.state.Form;
        if (localState.Offer !== '') {
            this.props.AddOffer(localState.Offer,this.props.FormId);
            localState.Status = true;
            this.setState({Form : localState});
           //set user submitted
           cookies.setItem("UserStatus",2,undefined, "/", undefined, true); 
        }
    }

    render() {
   var userStatus = cookies.getItem("UserStatus");

        return (
            <React.Fragment>
                <div className="row form-status__container">
                    <div className="col-md-12">
                        <div className="row status__container" >
                            <div className="col-md-12">
                                <img src='/DesktopModules/Faratech.PakdisSurvey/Web/static/img/success.gif' width="150" />
                            </div>
                            {userStatus === "1" ?
                                <React.Fragment>
                                    {/* if offer submit */}
                                    {this.state.Form.Status == false ?
                                        <React.Fragment>
                                            <div className="col-md-12 text__container">
                                                با تشکر از همکاری شما ، لطفا در صورت وجود هر گونه پیشنهاد و یا انتقاد در مورد محصولات این شرکت نظر خود را ذکر فرمائید.
                                           </div>

                                            <input
                                                type="text"
                                                className="form-control survay-box"
                                                placeholder="نظرات خود را با ما درمیان بگذارید ..."
                                                value={this.state.Form.Offer}
                                                onChange={(e) => {
                                                    this.BindInput("Form", "Offer", e.target);
                                                }}
                                            />

                                            <button type="submit"
                                                className="btn btn-success"
                                                onClick={(e) => { this.handleSubmitOffer(e) }}>
                                                ثبت نظر
                                             </button>

                                             <a className="btn btn-default return-btn" href="/">بازگشت</a>
                                        </React.Fragment>
                                        :
                                        <div className="col-md-12 text__container">
                                            با تشکر از ثبت نظر شما ....
                                       </div>
                                    }
                                </React.Fragment>
                                :
                                <div className="col-md-12 text__container">
                                    فرم توسط شما به ثبت رسیده است .
                         </div>}
                        </div>
                    </div>
                </div>
            </React.Fragment >
        );
    };
}
var mapDispatchToProps = function (dispatch) {
    return {
        AddOffer: (data,formId) => dispatch(addOffer(data,formId))
    };
}

const mapStateToProps = function (state) {
    return {
        Question: state.Survey.Questions,
        Answer: state.Survey.Answers
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Result);



// WEBPACK FOOTER //
// ./src/Components/Requests/com.survay.result.jsx